// src/components/icons/FavoriteIcon.jsx
import React from 'react';

const FavoriteIcon = ({ isFavorite = false }) => (
  <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path 
      d="M9.5225 14.7404C9.28167 14.8254 8.885 14.8254 8.64417 14.7404C6.59 14.0391 2 11.1137 2 6.15538C2 3.96663 3.76375 2.1958 5.93833 2.1958C7.2275 2.1958 8.36792 2.81913 9.08333 3.78247C9.79875 2.81913 10.9463 2.1958 12.2283 2.1958C14.4029 2.1958 16.1667 3.96663 16.1667 6.15538C16.1667 11.1137 11.5767 14.0391 9.5225 14.7404Z" 
      stroke={isFavorite ? "#E10611" : "black"} 
      fill={isFavorite ? "#E10611" : "none"}
      strokeOpacity="0.6" 
      strokeWidth="1.1087" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
  </svg>
);

export default FavoriteIcon;